<template>
  <Form
    :class="['el-form--main', isEditable ? '' : 'el-form--main-disabled']"
    :model="invoice"
    :rules="validationRules"
  >
    <BlockWrapper no-bottom-padding>
      <BasicSettings
        class="basic-settings"
      />
    </BlockWrapper>

    <BlockWrapper no-bottom-padding>
      <GeneralSettings />
    </BlockWrapper>

    <BlockWrapper no-bottom-padding>
      <Row spacing="md">
        <Column
          :xs="24"
          :md="12"
        >
          <InvoiceBuyer />
        </Column>
        <Column
          :xs="24"
          :md="12"
        >
          <InvoiceSeller />
        </Column>
      </Row>
    </BlockWrapper>

    <BlockWrapper>
      <InvoiceItems />
      <InvoiceNotes />
      <InvoiceSummary />
      <RecurringSettings />
      <SubmitInvoiceDialog />
    </BlockWrapper>

    <ActionButtons />
  </Form>
</template>

<script>
import { mapGetters } from 'vuex';

import BlockWrapper from '~/modules/layout/BlockWrapper.vue';
import ActionButtons from './sections/ActionButtons.vue';
import BasicSettings from './sections/BasicSettings.vue';
import GeneralSettings from './sections/GeneralSettings.vue';
import InvoiceBuyer from './sections/InvoiceBuyer.vue';
import InvoiceItems from './sections/InvoiceItems.vue';
import InvoiceNotes from './sections/InvoiceNotes.vue';
import InvoiceSeller from './sections/InvoiceSeller.vue';
import InvoiceSummary from './sections/InvoiceSummary.vue';
import RecurringSettings from './sections/RecurringSettings.vue';
import SubmitInvoiceDialog from '../../dialogs/SubmitInvoiceDialog.vue';

export default {
  provide() {
    const data = {};
    Object.defineProperty(data, 'invoice', {
      enumerable: true,
      get: () => this.invoice,
    });
    Object.defineProperty(data, 'elInvoiceForm', {
      enumerable: true,
      get: () => this,
    });

    return data;
  },
  components: {
    ActionButtons,
    BasicSettings,
    BlockWrapper,
    GeneralSettings,
    InvoiceBuyer,
    InvoiceItems,
    InvoiceNotes,
    InvoiceSeller,
    InvoiceSummary,
    RecurringSettings,
    SubmitInvoiceDialog,
  },
  props: {
    isEditEetInvoiceDisabled: Boolean,
    correctionInvoiceRedirect: Function,
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('invoiceForm', ['invoice', 'fieldsDisabled', 'validationRules']),
    ...mapGetters('auth', ['isAuthorized']),
  },
  mounted() {
    this.$store.dispatch('invoiceForm/computeVisibilities');
    this.$store.dispatch('invoiceForm/computeFieldsDisabled');
    if (this.isAuthorized) {
      this.$store.dispatch('lineSuggestions/getSuggestions');
    }
  },
};
</script>

<style lang="scss">
.separator {
  margin-bottom: rem(25);
  margin-top: rem(25);
  border-bottom: 1px solid $--color-light-blue-new;
  display: block;
}

.el-color-dropdown__link-btn {
  display: none;
}
</style>

<style lang="scss" scoped>
.el-form--main-disabled {
  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    background: rgba($--color-white, .65);
    z-index: 1000;
  }
}
</style>
